import React from "react";
import { Box } from "@mui/material";

export const MOVEMENT_COLORS = { up: "#16a34a", down: "#dc2626" };

/** Green ▲ / red ▼ for places gained or lost since the previous matchday; empty space when unchanged. */
export default function MovementArrow({ movement, showCount = false, size = 9, sx }) {
  const n = Number(movement) || 0;
  const up = n > 0;
  const label = n === 0 ? undefined : `${up ? "Up" : "Down"} ${Math.abs(n)} place${Math.abs(n) === 1 ? "" : "s"} since last matchday`;
  return (
    <Box
      component="span"
      role={label ? "img" : undefined}
      aria-label={label}
      title={label}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "2px",
        minWidth: size + 2,
        color: up ? MOVEMENT_COLORS.up : MOVEMENT_COLORS.down,
        fontSize: "0.62rem",
        fontWeight: 800,
        lineHeight: 1,
        fontVariantNumeric: "tabular-nums",
        flexShrink: 0,
        ...sx,
      }}
    >
      {n !== 0 && (
        <>
          <Box
            component="span"
            aria-hidden
            sx={{
              width: 0,
              height: 0,
              borderLeft: `${size / 2 + 1}px solid transparent`,
              borderRight: `${size / 2 + 1}px solid transparent`,
              [up ? "borderBottom" : "borderTop"]: `${size}px solid currentColor`,
            }}
          />
          {showCount && <span aria-hidden>{Math.abs(n)}</span>}
        </>
      )}
    </Box>
  );
}
